// extracted by mini-css-extract-plugin
module.exports = {"hotspotComponentWrapper":"m9","slider-wrapper":"m-"};